import type { ReactNode } from 'react';

export const kawaiiLinkBaseDefaultStyles =
  'disabled:opacity-50 px-4 py-2 font-medium rounded-full transition-all duration-200 ease-in-out relative bg-white/50 dark:bg-gray-700/50 text-gray-800 dark:text-gray-200 cursor-pointer'; // Added default text colors too

// Hover styles specifically for KawaiiLink (matching your example)
export const kawaiiLinkHoverStyles = 'hover:bg-pink-200 dark:hover:bg-pink-800';

// ---

export const kawaiiBaseStyles =
  'disabled:opacity-50 relative group px-4 py-2 rounded-full transition-all duration-200 ease-in-out flex items-center justify-center gap-2 font-medium cursor-pointer';

// Focus ring styles
export const kawaiiFocusStyles =
  'focus:outline-hidden focus:ring-2 focus:ring-pink-400 dark:focus:ring-pink-500 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-900';

// Hover glow effect (uses 'group-hover')
export const kawaiiHoverGlowStyles = '';

// Variant specific styles (separated base and hover)
export const kawaiiVariantStyles = {
  primary: {
    base: 'bg-pink-500 border border-pink-300 dark:border-pink-800 dark:bg-gray-800  dark:bg-pink-900 text-white',
    hover: 'hover:bg-pink-600 dark:hover:bg-pink-800',
    active: 'active:bg-pink-700 dark:active:bg-pink-800',
  },
  secondary: {
    base: 'bg-white border border-pink-200 dark:border-gray-700 dark:bg-gray-800 text-gray-800 dark:text-gray-300',
    hover: 'hover:bg-gray-50 dark:hover:bg-gray-100/20',
    active: 'active:bg-gray-100 dark:active:bg-pink-300/30',
  },
};

export const kawaiiActiveStyles =
  '[&.active]:bg-pink-200 dark:[&.active]:bg-pink-800 [&.active]:text-pink-700 dark:[&.active]:text-pink-200';

export interface KawaiiBaseProps {
  children: ReactNode;
  variant?: keyof typeof kawaiiVariantStyles;
  icon?: ReactNode;
  fullWidth?: boolean;
  className?: string;
}
